module.exports = __webpack_public_path__ + "static/img/link.a980e5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/link.png
// module id = TIal
// module chunks = 1